import configureApp from 'configureApp';

export const clientBaseUrl = `${configureApp.clientBaseUrl}/me/default-translations`;
